// removed by extract-text-webpack-plugin
module.exports = {"message":"MessageToaster__message__2BCxO","messageIsMobile":"MessageToaster__messageIsMobile__1JTkw"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/MessageToaster/MessageToaster.scss
// module id = 1616
// module chunks = 0